export let hrms32eColumns = () => {
  let indexColumns = [{
    key: 'codempid_query',
    name: '',
    labelCodapp: 'HRMS32EC1',
    labelIndex: '30',
    class: 'align-center',
    style: 'min-width: 120px;'
  }, {
    key: 'desc_codempid_query',
    name: '',
    labelCodapp: 'HRMS32EC1',
    labelIndex: '40',
    style: 'min-width: 200px;'
  }, {
    key: 'dtereq',
    name: '',
    labelCodapp: 'HRMS32EC1',
    labelIndex: '50',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'desc_typchg',
    name: '',
    labelCodapp: 'HRMS32EC1',
    labelIndex: '60',
    style: 'min-width: 200px;'
  }, {
    key: 'numseq',
    name: '',
    labelCodapp: 'HRMS32EC1',
    labelIndex: '65',
    class: 'align-center',
    style: 'min-width: 80px;'
  }, {
    key: 'status',
    name: '',
    labelCodapp: 'HRMS32EC1',
    labelIndex: '70',
    style: 'min-width: 200px;'
  }, {
    key: 'remarkap',
    name: '',
    labelCodapp: 'HRMS32EC1',
    labelIndex: '80',
    style: 'min-width: 200px;'
  }, {
    key: 'codappr',
    name: '',
    labelCodapp: 'HRMS32EC1',
    labelIndex: '90',
    style: 'min-width: 200px;'
  }, {
    key: 'next_appr',
    name: '',
    labelCodapp: 'HRMS32EC1',
    labelIndex: '190',
    style: 'min-width: 200px;'
  }]

  let detail2Tab7TableColumns = [{
    key: 'typdoc',
    name: '',
    labelCodapp: 'HRMS32EC15',
    labelIndex: '40',
    style: 'min-width: 200px;',
    inlineType: 'select',
    inlineDropdown: {},
    validateRules: 'required'
  }, {
    key: 'namdoc',
    name: '',
    labelCodapp: 'HRMS32EC15',
    labelIndex: '50',
    style: 'min-width: 200px;',
    inlineType: 'text',
    validateRules: 'required|max:20'
  }, {
    key: 'dterecv',
    name: '',
    labelCodapp: 'HRMS32EC15',
    labelIndex: '60',
    class: 'align-center',
    style: 'min-width: 200px;',
    inlineType: 'date',
    validateRules: 'required',
    dataType: 'date'
  }, {
    key: 'dtedocen',
    name: '',
    labelCodapp: 'HRMS32EC15',
    labelIndex: '70',
    class: 'align-center',
    style: 'min-width: 200px;',
    inlineType: 'date',
    validateRules: 'required',
    dataType: 'date'
  }, {
    key: 'numdoc',
    name: '',
    labelCodapp: 'HRMS32EC15',
    labelIndex: '80',
    style: 'min-width: 200px;',
    inlineType: 'text',
    validateRules: 'max:30'
  }, {
    key: 'filedoc',
    name: '',
    labelCodapp: 'HRMS32EC15',
    labelIndex: '90',
    style: 'min-width: 300px;',
    inlineType: 'upload'
  }, {
    key: 'desnote',
    name: '',
    labelCodapp: 'HRMS32EC15',
    labelIndex: '100',
    style: 'min-width: 200px;',
    inlineType: 'text',
    validateRules: 'max:500'
  }, {
    key: 'desc_status',
    name: '',
    labelCodapp: 'HRMS32EC13',
    labelIndex: '60',
    class: 'align-center',
    style: 'min-width: 150px;'
  }]

  let detail3TableColumns = [{
    key: 'codedlv',
    name: '',
    labelCodapp: 'HRMS32EC12',
    labelIndex: '30',
    style: 'min-width: 200px;',
    inlineType: 'select',
    inlineDropdown: {}
  }, {
    key: 'coddglv',
    name: '',
    labelCodapp: 'HRMS32EC12',
    labelIndex: '40',
    style: 'min-width: 200px;',
    inlineType: 'select',
    inlineDropdown: {}
  }, {
    key: 'codmajsb',
    name: '',
    labelCodapp: 'HRMS32EC12',
    labelIndex: '50',
    class: 'align-center',
    style: 'min-width: 120px;',
    inlineType: 'select',
    inlineDropdown: {}
  }, {
    key: 'codminsb',
    name: '',
    labelCodapp: 'HRMS32EC12',
    labelIndex: '60',
    style: 'min-width: 200px;',
    inlineType: 'select',
    inlineDropdown: {}
  }, {
    key: 'codinst',
    name: '',
    labelCodapp: 'HRMS32EC12',
    labelIndex: '70',
    style: 'min-width: 200px;',
    inlineType: 'select',
    inlineDropdown: {}
  }, {
    key: 'codcount',
    name: '',
    labelCodapp: 'HRMS32EC12',
    labelIndex: '80',
    style: 'min-width: 200px;',
    inlineType: 'select',
    inlineDropdown: {}
  }, {
    key: 'stayear',
    name: '',
    labelCodapp: 'HRMS32EC12',
    labelIndex: '100',
    class: 'align-center',
    style: 'min-width: 120px;',
    inlineType: 'text',
    validateRules: 'numeric|max:4'
  }, {
    key: 'dtegyear',
    name: '',
    labelCodapp: 'HRMS32EC12',
    labelIndex: '110',
    class: 'align-center',
    style: 'min-width: 120px;',
    inlineType: 'text',
    validateRules: 'numeric|max:4',
    dataType: 'year'
  }, {
    key: 'numgpa',
    name: '',
    labelCodapp: 'HRMS32EC12',
    labelIndex: '90',
    class: 'align-center',
    style: 'min-width: 100px;',
    inlineType: 'text',
    validateRules: 'decimal:2|max:6'
  }, {
    key: 'flgeduc',
    name: '',
    labelCodapp: 'HRMS32EC12',
    labelIndex: '120',
    style: 'min-width: 200px;',
    inlineType: 'select',
    inlineDropdown: {}
  }, {
    key: 'desc_status',
    name: '',
    labelCodapp: 'HRMS32EC9',
    labelIndex: '80',
    class: 'align-center',
    style: 'min-width: 150px;'
  }]

  let detail4TableColumns = [{
    key: 'namchild',
    name: '',
    labelCodapp: 'HRMS32EC10',
    labelIndex: '20',
    style: 'min-width: 200px;',
    inlineType: 'text',
    validateRules: 'max:60'
  }, {
    key: 'numoffid',
    name: '',
    labelCodapp: 'HRPMC2E12',
    labelIndex: '30',
    style: 'min-width: 200px;',
    inlineType: 'text',
    validateRules: 'max:13'
  }, {
    key: 'dtechbd',
    name: '',
    labelCodapp: 'HRMS32EC10',
    labelIndex: '30',
    class: 'align-center',
    style: 'min-width: 200px;',
    inlineType: 'date',
    validateRules: 'required',
    dataType: 'date'
  }, {
    key: 'namsex',
    name: '',
    labelCodapp: 'HRMS32EC10',
    labelIndex: '40',
    style: 'min-width: 200px;',
    inlineType: 'select',
    inlineDropdown: {}
  }, {
    key: 'flgedlv',
    name: '',
    labelCodapp: 'HRPMC2E12',
    labelIndex: '60',
    style: 'min-width: 200px;',
    inlineType: 'select',
    inlineDropdown: {}
  }, {
    key: 'codedlv',
    name: '',
    labelCodapp: 'HRMS32EC10',
    labelIndex: '50',
    style: 'min-width: 200px;',
    inlineType: 'select',
    inlineDropdown: {}
  }, {
    key: 'flgdeduct',
    name: '',
    labelCodapp: 'HRPMC2E12',
    labelIndex: '70',
    style: 'min-width: 200px;',
    inlineType: 'select',
    inlineDropdown: {}
  }, {
    key: 'desc_status',
    name: '',
    labelCodapp: 'HRMS32EC10',
    labelIndex: '60',
    class: 'align-center',
    style: 'min-width: 150px;'
  }]

  let detail6TableColumns = [{
    key: 'destrain',
    name: '',
    labelCodapp: 'HRMS32EC13',
    labelIndex: '20',
    style: 'min-width: 200px;',
    inlineType: 'text',
    validateRules: 'max:100'
  }, {
    key: 'dateTraining',
    name: '',
    labelCodapp: 'HRMS32EC13',
    labelIndex: '30',
    class: 'align-center',
    style: 'min-width: 240px;',
    headerRow: 1,
    colspan: 2,
    rowspan: 1
  }, {
    key: 'dtetrain',
    name: '',
    labelCodapp: 'HRESH7XC1',
    labelIndex: '50',
    class: 'align-center',
    style: 'min-width: 120px;',
    headerRow: 2,
    colspan: 1,
    rowspan: 1,
    inlineType: 'date',
    dataType: 'date'
  }, {
    key: 'dtetren',
    name: '',
    labelCodapp: 'HRESH7XC1',
    labelIndex: '60',
    class: 'align-center',
    style: 'min-width: 120px;',
    headerRow: 2,
    colspan: 1,
    rowspan: 1,
    inlineType: 'date',
    dataType: 'date'
  }, {
    key: 'desplace',
    name: '',
    labelCodapp: 'HRMS32EC13',
    labelIndex: '40',
    style: 'min-width: 200px;',
    inlineType: 'text',
    validateRules: 'max:30'
  }, {
    key: 'desinstu',
    name: '',
    labelCodapp: 'HRMS32EC13',
    labelIndex: '50',
    style: 'min-width: 200px;',
    inlineType: 'text',
    validateRules: 'max:50'
  }, {
    key: 'desc_status',
    name: '',
    labelCodapp: 'HRMS32EC13',
    labelIndex: '60',
    class: 'align-center',
    style: 'min-width: 150px;'
  }]

  return {
    en: {
      index: indexColumns,
      detail2Tab7Table: detail2Tab7TableColumns,
      detail3Table: detail3TableColumns,
      detail4Table: detail4TableColumns,
      detail6Table: detail6TableColumns
    },
    th: {
      index: indexColumns,
      detail2Tab7Table: detail2Tab7TableColumns,
      detail3Table: detail3TableColumns,
      detail4Table: detail4TableColumns,
      detail6Table: detail6TableColumns
    }
  }
}
export let detail6TableMaxRowspan = {
  index: 2,
  detail6TableMaxRowspan: 2
}



// WEBPACK FOOTER //
// ./src/assets/columns/hrms32e.js